import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import { useIslandPortalContainer } from "@frontend/contexts";

import type { DrawerPortalProps } from "./Drawer.types";

export function DrawerPortal({
  children,
  container,
  ...props
}: DrawerPortalProps): JSX.Element {
  const islandContainer = useIslandPortalContainer();

  return (
    <BaseDrawer.Portal
      data-slot="drawer-portal"
      container={container ?? islandContainer}
      {...props}
    >
      {children}
    </BaseDrawer.Portal>
  );
}
